import React, { useRef, useState } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { QRCodeCanvas } from 'qrcode.react';
import Swal from 'sweetalert2';
import CustomPrintCert3 from './CustomPrintCert3';
import { calculateAge } from '../../util/valueCalculator';
import { nombreApellidosFullPersona } from '../../util/customFormatter';

const AfiliadoCert3 = ({ show, handleClose, afiliado }) => {
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [qrDataURL, setQrDataURL] = useState('');
    const [certObjectText, setCertObjectText] = useState('');
    const [printDisabled, setPrintDisabled] = useState(false);
    const [isDraft, setIsDraft] = useState(false);
    const qrRef = useRef();

    // No hay número comprado; por ahora: S/N
    const numeroCertificado = 'S/N';

    const tiempoServicio = calculateAge(afiliado.fecha_reg_cab, new Date());

    const handleGenerateQR = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (!canvas) return;
        const qrImageData = canvas.toDataURL('image/png');
        setQrDataURL(qrImageData);
    };

    const handlePrintConfirmation = async () => {
        const result = await Swal.fire({
            title: 'Confirmación',
            text: 'Verifica los datos antes de proceder.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
            handleGenerateQR();
            setShowPrintModal(true);
            setPrintDisabled(true);
            setIsDraft(false);
        }
    };

    const handleDraftPrint = () => {
        handleGenerateQR();
        setShowPrintModal(true);
        setIsDraft(true);
    };

    const handlePrintModalClose = () => {
        setShowPrintModal(false);
        if (!isDraft) {
            setPrintDisabled(true);
        }
    };

    const handlePrint = () => {
        handlePrintConfirmation();
    };

    const handleObjectTextChange = (e) => {
        setCertObjectText(e.target.value);
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Detalles del Certificado de No Sanción</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-4">
                        <Col>
                            <h5>Datos del Afiliado</h5>
                            <p><strong>Nombre:</strong> {`${nombreApellidosFullPersona(afiliado.persona)}`}</p>
                            <p><strong>Número de Registro:</strong> {afiliado.num_reg}</p>
                            <p><strong>CI:</strong> {afiliado.persona.ci}</p>
                            <p><strong>Tiempo de Servicio:</strong> {`${tiempoServicio.years} años, ${tiempoServicio.months} meses, y ${tiempoServicio.days} días`}</p>
                        </Col>
                        <Col className="text-center" ref={qrRef}>
                            <h5>QR del Certificado</h5>
                            <QRCodeCanvas
                                value={`Certificado NO SANCIÓN: ${numeroCertificado}, Nombre: ${nombreApellidosFullPersona(afiliado.persona, "ci")}, Registro: ${afiliado.num_reg}`}
                                size={128}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Objeto del Certificado (opcional)</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Ej: Presentación a licitación, trámite institucional, etc."
                                    value={certObjectText}
                                    onChange={handleObjectTextChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handlePrint}
                        disabled={printDisabled}
                    >
                        Generar Certificado
                    </Button>
                    <Button
                        variant="info"
                        onClick={handleDraftPrint}
                    >
                        Ver Borrador
                    </Button>
                </Modal.Footer>
            </Modal>

            {showPrintModal && (
                <CustomPrintCert3
                    show={showPrintModal}
                    handleClose={handlePrintModalClose}
                    afiliado={afiliado}
                    numeroCertificado={numeroCertificado}
                    aserv={`${tiempoServicio.years} años y ${tiempoServicio.months} meses`}
                    qrDataURL={qrDataURL}
                    certObjectText={certObjectText.toUpperCase()}
                    copia={isDraft}
                />
            )}
        </>
    );
};

export default AfiliadoCert3;